/**
 * Distingue les images de forme vectorielles (SVG) des rasters (photos CDN) — logique pure,
 * testable sans DOM/carte. `MapLibreAdapter` s'en sert pour aiguiller chaque forme-image vers l'un
 * de ses deux chemins de rendu : SVG en `<img>` DOM (derrière le canvas, netteté vectorielle
 * préservée), raster en layer MapLibre (dans le canvas, empilement unifié avec les formes via
 * `Shape.layer` — voir BESOINS.md §4/§8). Appliquée sur `Shape.image.src` BRUT, avant
 * `resolveImageUrl` : un resolver CDN (ex. Akamai) peut réécrire l'URL/l'extension, alors que le
 * format d'origine de l'image ne change pas.
 */
export function isSvgImageSrc(src: string): boolean {
  return src.startsWith("data:image/svg+xml") || /\.svg(\?|#|$)/i.test(src);
}

/**
 * Décide si l'image d'une forme est un SVG — priorité à `Shape.image.svg` (explicite, voir
 * `jsonLoader`/`extra.imageSvg` en v1, `extra.image.svg` en v2 — voir BESOINS.md §8.2) quand
 * il est fourni : nécessaire car certaines URLs (CDN
 * sans extension, servant aussi bien du SVG que du raster) ne permettent pas de trancher par leur
 * seule forme — voir BESOINS.md §14. Sans cette information explicite, retombe sur `isSvgImageSrc`
 * (préfixe `data:image/svg+xml` ou extension `.svg`).
 */
export function isSvgShapeImage(src: string, svg?: boolean): boolean {
  return svg ?? isSvgImageSrc(src);
}
